import { isConnectedAccount } from 'owa-accounts-store';
import { initializeLocationMetrics } from '../mutators/eventMetricsMutators';
import { CharmSelectionType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { lazyInitializeCache } from 'owa-recipient-cache';
import { orchestrator } from 'satcheljs';
import {
    initializeCompose,
    initializeCalendarEvents,
    updateCharmSelectionType,
    updateOpenedForm,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(initializeCompose, actionMessage => {
    let event: CalendarEvent = actionMessage.event;

    initializeCalendarEvents(event);

    // Setting the opened form within the initialization to ensure it doesn't get set before the form is initialized
    if (actionMessage.formType) {
        updateOpenedForm(actionMessage.formType);
    }

    if (event.ItemId?.Id) {
        // When we have an id, we are initializing from edit peek.
        if (event.CharmId == null || event.CharmId == 0) {
            updateCharmSelectionType(CharmSelectionType.None);
        } else {
            // A charm is already set, so charm selection type is set to manual
            // this will disable autosuggestions
            updateCharmSelectionType(CharmSelectionType.Manual);
        }
    } else {
        updateCharmSelectionType(CharmSelectionType.None);
    }

    initializeLocationMetrics();

    if (!isConnectedAccount(event.ParentFolderId.mailboxInfo.userIdentity)) {
        lazyInitializeCache.importAndExecute();
    }
});
